import { render, staticRenderFns } from "./SalaryPackagingProvider.vue?vue&type=template&id=1a1d4886&"
import script from "./SalaryPackagingProvider.vue?vue&type=script&lang=js&"
export * from "./SalaryPackagingProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports